import React from "react";
import {Typography, Button, Stack, useMediaQuery, Box} from "@mui/material";
// import RocketryButton from "../components/RocketryButton";
import Footer from "../sections/Footer";
// import {Events} from "../sections/Events";
// import { Timeline, Bookmark } from "../vertical-progress-timeline";
// import MyTimeLine from "../components/MyTimeLine";
import Header from "../Header";
import {Calendar, DefaultCalendarEventRenderer, defaultTheme} from 'react-native-big-calendar';
import rawEvents from "../events.json";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import dayjs from "dayjs";

const calendarTheme = {
    ...defaultTheme,

    // 👇 The one your calendar actually uses
    weekDayHeaderHighlightColor: "#000",
    typography:{
        sm:{
            fontSize: 16,
        }
    },

    palette: {
        ...defaultTheme.palette,
        gray: {
            ...defaultTheme.palette?.gray,   // in case the default theme already has some
            500: "#000",                  // your gray[500] value
        },
        primary: {
            ...defaultTheme.palette.primary,
            main: "#000",       // fallback if highlight color missing
        },
    },
};


function Main(locales) {

    const isSmall = useMediaQuery('(max-width: 768px)');
    // const events = [
    //     {
    //         title: 'Meeting',
    //         start: new Date(2025, 10, 27, 10, 0),
    //         end: new Date(2025, 10, 27, 10, 30),
    //     },
    //     {
    //         title: 'Rocket Launch Workshop',
    //         start: new Date(2025, 10, 28, 15, 45),
    //         end: new Date(2025, 10, 28, 16, 30),
    //     },
    //     {
    //         title: 'Competition',
    //         start: new Date(2025, 11, 11, 15, 45),
    //         end: new Date(2025, 11, 11, 16, 30),
    //     },
    // ];


    const events = rawEvents.map(e => ({
        ...e,
        start: new Date(e.start),
        end: new Date(e.end)
    })).sort((a, b) => a.start - b.start);


    // return (
        // <React.Fragment>
        //     <Box
        //         sx={{
        //             height: "100vh",
        //             overflowY: "scroll",
        //             // scrollSnapType: "y mandatory",
        //             scrollbarWidth: "none",
        //             "&::-webkit-scrollbar": { display: "none" },
        //         }}
        //     >
        //         <Header />
        //
        //     {/*<MyTimeLine />*/}
        //         <Calendar events={events} height={600}
        //         mode={"month"}
        //         />
        //
        //     <Footer />
        //
        //     </Box>
        //
        // </React.Fragment>
    // );
    const [currentDate, setCurrentDate] = React.useState(new Date());

return (
    <Box
        sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",

        }}
    >
        <Header />
        <Stack

            direction="column"
            spacing={0}
            sx={{
                // height: "100vh",
                scrollSnapAlign: "start",
                backgroundColor: "black",
                color: "#fff",
                display: "flex",
                background: "#A8ACB0",
                flexDirection: "column",
                // alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                flexGrow: 1,

                p: 2
            }}
        >
            <Stack
                sx={{

                    display: isSmall ? "none" :  "flex",
                    background: "#A8ACB0",
                    // alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    p: 2,


                }}
                direction="row" spacing={1}

            >
                <Button onClick={() => setCurrentDate(new Date(dayjs(currentDate).add(-1, "month")))}>
                    <ArrowBackIcon />
                </Button>
                <Typography variant="h5" component="h5" sx={{color: 'black'}}><b>{currentDate.toLocaleString('en-UK', { month: "long", year: "numeric" })}</b></Typography>
                <Button onClick={() => setCurrentDate(new Date(dayjs(currentDate).add(1, "month")))}>
                    <ArrowForwardIcon />

                </Button>


            </Stack>

                     <Calendar events={events}
                               mode={isSmall ? "schedule" : "month"}
                               // cellsBorderStyle={{border: "solid 10px black", backgroundColor: "black"}}
                                date={currentDate}
                               verticalScrollEnabled={true}
                               swipeEnabled={true}
                               calendarCellAccessibilityPropsForMonthView={true}
                               showAdjacentMonths={true}

                               scrollOffsetMinutes={(new Date()).getHours() * 60}
                               eventCellTextColor={"#a11"}
                               calendarCellStyle={{
                                   borderWidth: 1,
                                   // borderColor: "#ddd",

                               }}


                               scheduleMonthSeparatorStyle={{marginLeft: isSmall ? "15%" : 0, color:"green"}}
                               renderEvent={(_event, touchableOpacityProps) => {

                                   return (

                                       <DefaultCalendarEventRenderer
                                           event={_event}
                                           showTime={true}
                                           ampm={false}
                                           touchableOpacityProps={touchableOpacityProps}
                                           textColor={"#000"}


                                       />
                                   )
                               }}
                               theme={calendarTheme}


                               onSwipeEnd={(date) => {
                                   setCurrentDate(date);
                               }}
                               eventCellStyle={{justifyContent: "space-evenly", alignItems: "center", backgroundColor: "var(--gold)",

                                   color: "#000",
                                }}


                     height={600}/>



        </Stack>

        <Footer />

    </Box>
);


}

export default Main;